import { ref } from "vue";

type Theme = "dark" | "light";

const STORAGE_KEY = "terra-theme";

function getStoredTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "light" ? "light" : "dark";
}

const currentTheme = ref<Theme>(getStoredTheme());

export function useTheme() {
  function applyTheme(theme: Theme) {
    if (theme === "light") {
      document.documentElement.setAttribute("data-theme", "light");
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
    localStorage.setItem(STORAGE_KEY, theme);
    currentTheme.value = theme;
  }

  function toggleTheme() {
    document.documentElement.classList.add("theme-transition");
    const next: Theme = currentTheme.value === "dark" ? "light" : "dark";
    applyTheme(next);
    setTimeout(() => {
      document.documentElement.classList.remove("theme-transition");
    }, 350);
  }

  function isDark(): boolean {
    return currentTheme.value === "dark";
  }

  return {
    currentTheme,
    toggleTheme,
    applyTheme,
    isDark,
  };
}
